import { Component, Input, OnInit } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { ActivatedRoute, Router } from '@angular/router';
import { UnifiedAuthService } from 'app/services/yoklama/auth.service';
import { DeviceService } from 'app/services/yoklama/devices-services';
import { CMSDynamicService } from 'app/services/yoklama/cms-service';
import { CustomToastrService, ToastrMessageType, ToastrPosition } from 'app/base/services/custom-toast-service';

@Component({
  selector: 'app-device-verification',
  templateUrl: './device-verification.component.html',
  styleUrls: ['./device-verification.component.css']
})
export class DeviceVerificationComponent implements OnInit {

  @Input() deviceId: string = '';


  phoneNumber: string = '';
  deviceName: string = '';
  smsCode: string = '';

  deviceCount: number = 0;
  isCodeSent = false;
  smsId = 0;

  user: any;

  constructor(
    public auth: UnifiedAuthService,
    private http: CMSDynamicService,
    private deviceService: DeviceService,
    public router: Router,
    private route: ActivatedRoute,
    public alertService: CustomToastrService,

  ) {}

  async ngOnInit() {
    this.user = this.auth.userValue;
 this.deviceId = this.route.snapshot.paramMap.get('deviceId')!;
    this.deviceCount = JSON.parse(localStorage.getItem('userList') || '0').data.slice(-1)[0].deviceChangedCount;
    this.phoneNumber = this.user?.data?.[0]?.telefonNumarasi ?? '';
  }

 async sendSms() {
  const body = {
    id: this.user?.data?.slice(-1)[0].deviceTableId,
    deviceName: this.deviceName,
    deviceUserId: this.user.data[0].birimler[0].ogrenciNumarasi,
    deviceId: this.deviceId,
    phoneNumber: this.phoneNumber,
  };

  try {


    const res = await this.http.postSMS('Yoklama', 'AddDevice', '', body,false);



    if (res?.smsCode) {
      this.isCodeSent = true;
      this.smsId = res.smsId;
      this.alertService.message('SMS gönderildi', 'Başarılı', { messageType: ToastrMessageType.Success, position: ToastrPosition.TopFullWidth });
    } else {
      this.alertService.message('SMS gönderilemedi', 'Hata', { messageType: ToastrMessageType.Error, position: ToastrPosition.TopFullWidth });
    }
  } catch (err) {
    console.error('SMS gönderme hatası', err);
    this.alertService.message('Bir hata oluştu', 'Hata', { messageType: ToastrMessageType.Error, position: ToastrPosition.TopFullWidth });
  }
}

async verifySmsCode() {
  const detail = this.user.data.slice(-1)[0];
  const body = {
    id: detail.deviceTableId,
    deviceUserId: parseInt(this.user.data[0].birimler[0].ogrenciNumarasi),
    Id: this.smsId,
    deviceId: this.deviceId,
    code: this.smsCode,
    isVerified: false,
    deviceName: this.deviceName,
    phoneNumber: this.phoneNumber,
  };

  try {
    const res = await this.http.post('Yoklama', 'UpdateSmsVerification', '', body ,false);

    if (res?.isVerified) {


      const isRegistered = await this.deviceService.checkDeviceRegistered(this.deviceId);
      if (isRegistered) {
        this.alertService.message('Cihaz zaten kayıtlı.', 'Uyarı', { messageType: ToastrMessageType.Warning, position: ToastrPosition.TopFullWidth });
        return;
      }

      await this.deviceService.saveOrUpdateDeviceId(this.deviceId);

      detail.deviceId = this.deviceId;
      detail.deviceChangedCount = detail.deviceChangedCount - 1;

      localStorage.setItem('userList', JSON.stringify(this.user));

      this.alertService.message('Doğrulama başarılı. Cihaz kaydı tamamlandı.', 'Başarılı', { messageType: ToastrMessageType.Success, position: ToastrPosition.TopFullWidth });

      this.router.navigate(['/cihaz-yonetimi']);

    } else {
      this.alertService.message('Kod yanlış', 'Hata', { messageType: ToastrMessageType.Error, position: ToastrPosition.TopFullWidth });
    }

  } catch (err) {
    console.error('SMS doğrulama hatası', err);
    this.alertService.message('Bir hata oluştu', 'Hata', { messageType: ToastrMessageType.Error, position: ToastrPosition.TopFullWidth });
  }
}

}
